import React, {Fragment, useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleModal } from '../store/actions/toggleModalActions';

import ButtonSpinner from './_common/ButtonSpinner';
import {addWeatherStation, deleteStation, editWeatherStation} from "../store/actions/weatherStationsActions";
import ExternalModal from "./_common/ExternalModal";
import UserAccessModal from "./_common/UserAccessModal";
import Sensor from "./Sensor";
import './WeatherStationModal.scss'
import searchIcon from '../assets/icons/plus.svg'
import ManageUsers from "./ManageUsers";
// import SensorsMap from "./SensorsMap";
import MapView from "./Maps/MapView";
import {isCompanyAdmin, isCustomer, isDistributorAdmin, isSuperAdmin} from "../helpers/helpers";


const selector = state => {
    const { language, disableButtons, stations, companies, modalState } = state;
    return {
        t: language.translator,
        disableButtons: disableButtons,
        // selected: stations.selected,
        companies: companies.companies,
        modalState: modalState
    }
};

const defaultForm = {
    name: '',
    fieldId: '',
    rainSensorId: '',
    windSpeedSensorId: '',
    wetLeafSensorId: '',
    draginoWetLeafSensorId: '',
    soilHumiditySensorId: '',
    userId: '',
    lat: '',
    lon: '',
    virtual: false,
    gcStationId: '',
    stationType: '',
    stationIdentifier: '',
}

const defaultNames = {
   rainSensorName: '',
   windSpeedSensorName: '',
   wetLeafSensorName: '',
   draginoWetLeafSensorName: '',
   soilHumiditySensorName: ''
}

const WeatherStationModal = props => {
    const {edit, details, station} = props;
    const { t, disableButtons, selected, modalState, companies } = useSelector(selector);
    const dispatch = useDispatch();

    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const [formValues, setFormValues] = useState({...defaultForm})
    const [nameValues, setNameValues] = useState({})
    const [sensorsModal, setSensorsModal] = useState({isOpen: false, type: '', enumType: '', name: ''})
    const [usersModal, setUsersModal] = useState({isOpen: false, name: ''})
    const [stationUsersAccessModal, setStationUsersAccessModal] = useState(false)
    const [mapHasBeenClicked, setMapHasBeenClicked] = useState(false);
    const [error, setError] = useState(false)

    const hasValidCoordinates = (lat, lon) => {
        return lat !== '' && lon !== '' && !Number.isNaN(Number(lat)) && !Number.isNaN(Number(lon));
    };

    const normalizeCoordinateValue = value => value.toString().trim();

    const getCoordinatesFromMap = (latlng) => {
        setMapHasBeenClicked(true);
        setFormValues({ ...formValues, lat: latlng.lat, lon: latlng.lng})
    };

    useEffect(() => {
        if(station) {
            setFormValues({
                id: station && station.id ? station.id.toString() : '',
                name: station && station.name ? station.name.toString() : '',
                fieldId: station && station.fieldId ? station.fieldId.toString() : '',
                rainSensorId: station && station.rainSensorId ? station.rainSensorId.toString() : '',
                windSpeedSensorId: station && station.windSpeedSensorId ? station.windSpeedSensorId.toString() : '',
                wetLeafSensorId: station && station.wetLeafSensorId ? station.wetLeafSensorId.toString() : '',
                draginoWetLeafSensorId: station && station.draginoWetLeafSensorId ? station.draginoWetLeafSensorId.toString() : '',
                soilHumiditySensorId: station && station.soilHumiditySensorId ? station.soilHumiditySensorId.toString() : '',
                userId: station && station.userId ? station.userId.toString() : '',
                code: station && station.code ? station.code.toString() : '',
                address: station && station.address ? station.address.toString() : '',
                lat: station && station.lat ? station.lat : '',
                lon: station && station.lon ? station.lon : '',
                virtual: station ? Boolean(station.virtual) : false,
                gcStationId: station && station.gcStationId ? station.gcStationId.toString() : '',
                stationType: station && station.stationType ? station.stationType.toString() : '',
                stationIdentifier: station && station.stationIdentifier ? station.stationIdentifier.toString() : '',
            })

            setNameValues({
                rainSensorName: station && station.rainSensor && station.rainSensor.name ? station.rainSensor.name : '',
                windSpeedSensorName: station && station.windSpeedSensor && station.windSpeedSensor.name ? station.windSpeedSensor.name : '',
                wetLeafSensorName: station && station.wetLeafSensor && station.wetLeafSensor.name ? station.wetLeafSensor.name : '' ,
                draginoWetLeafSensorName: station && station.draginoWetLeafSensor && station.draginoWetLeafSensor.name ? station.draginoWetLeafSensor.name : '',
                soilHumiditySensorName: station && station.soilHumiditySensor && station.soilHumiditySensor.name ? station.soilHumiditySensor.name : '',
                userName: station && station.userName  ? station.userName : ''
            })
        }
    },[]);

    const handleDeleteStationClick = () => {
        setDeleteConfirmation(!deleteConfirmation)
    };

    const stationMarker = station && station.lat != null && station.lon != null
        ? [{
            lat: station.lat,
            lng: station.lon,
            color: "#FFAC0C",
            name: station.name,
            id: station.id
        }]
        : [];

    const normalizedLat = normalizeCoordinateValue(formValues.lat);
    const normalizedLon = normalizeCoordinateValue(formValues.lon);

    const locationMarker = hasValidCoordinates(normalizedLat, normalizedLon)
        ? { lat: Number(normalizedLat), lng: Number(normalizedLon) }
        : null;

    const closeModal = () => {
        dispatch(toggleModal(false, ''));
    };

    const toggleSensorsModal = (type, enumType, name) => {
       setSensorsModal({isOpen: !sensorsModal.isOpen, type: type, enumType: enumType, name: name})
    }

    const toggleUsersModal = (name) => {
        setUsersModal({isOpen: !usersModal.isOpen, name: name})
    }

    const selectSensorId = (sensorType, sensor, sensorName, name) => {
        setFormValues({...formValues, [sensorType]: sensor.toString()})
        setNameValues({...nameValues, [sensorName]: name})
    }

    const selectUserId = (id, name) => {
        setFormValues({...formValues, userId: id.toString() })
        setNameValues({...nameValues, userName: name})
    }

    const handleAddStationClick = () => {
        const commonPayload = {
            ...formValues,
            virtual: Boolean(formValues.virtual)
        };
        const createPayload = {
            ...commonPayload,
            gcStationId: commonPayload.virtual && formValues.stationType !== 'EDWIN_WEATHER_STATION'
                ? formValues.gcStationId
                : '',
            stationType: commonPayload.virtual && formValues.stationType ? formValues.stationType : null,
            stationIdentifier: commonPayload.virtual && formValues.stationType === 'EDWIN_WEATHER_STATION'
                ? (formValues.stationIdentifier || null)
                : null
        };
        const updatePayload = {
            ...commonPayload,
            gcStationId: commonPayload.virtual && formValues.stationType !== 'EDWIN_WEATHER_STATION'
                ? formValues.gcStationId
                : ''
        };

        if(!isCustomer()) {
            if(formValues.name.length && formValues.userId.length) {
                if(!edit) {
                    dispatch(addWeatherStation(createPayload))
                } else {
                    dispatch(editWeatherStation(updatePayload))
                }
                closeModal()
            } else {
                setError(true)
                setTimeout(() => setError(false), 5000)
            }
        } else {
            if(formValues.name.length) {
                if(!edit) {
                    dispatch(addWeatherStation(createPayload))
                } else {
                    dispatch(editWeatherStation(updatePayload))
                }
                closeModal()
            } else {
                setError(true)
                setTimeout(() => setError(false), 5000)
            }
        }

    }


    const confirmDeleteWeatherStation = id => {
        dispatch(deleteStation(id))
        closeModal()
    }

    return (
        <div
            className={details ? 'userModalDetails' : 'userModalBlur'}
            onClick={e => {
                if(e.target.className === 'userModalBlur') {
                    closeModal()
                }
            }}
        >
            <div className={details ? 'userModal inDetails' : 'userModal'}>
                <div className="userModalHeader">
                    <div className="userModalTitleContainer">
                        <div className='userModalTitle'>
                            {!edit ? t.gettext('Add New Weather Station') : t.gettext('Edit Weather Station') }
                        </div>
                    </div>
                    <div className='userModalCloseButtonHolder'>
                        <span
                            className='material-icons userModalCloseButton'
                            onClick={closeModal}
                        >
                            cancel
                        </span>
                    </div>
                </div>
                <div style={!error ? {"visibility": "hidden"} : null} className='weatherStationError'>{t.gettext('Some required fields are missing')}.</div>
                <div className='userModalContent weatherStationContent'>
                    <form className='userForm' autoComplete='off'>
                        {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin()) && (
                            <Fragment>
                                <div className='stationMap'>
                                    <MapView
                                        zoom={12}
                                        center={{
                                            lat: station && station.lat ? station.lat : 52.2297,
                                            lng: station && station.lon ? station.lon : 21.0122
                                        }}
                                        markers={edit && !locationMarker ? stationMarker : null}
                                        locationMarker={locationMarker}
                                        centerOnLocationMarker={Boolean(locationMarker)}
                                        getCoordinates={getCoordinatesFromMap}
                                        mapHasBeenClicked={mapHasBeenClicked}
                                        avoidResize
                                    />
                                    {/*<SensorsMap*/}
                                    {/*    defaultZoom={12}*/}
                                    {/*    defaultCenter={{*/}
                                    {/*        lat: station && station.lat ? station.lat : 52.2297,*/}
                                    {/*        lng: station && station.lon ? station.lon : 21.0122*/}
                                    {/*    }}*/}
                                    {/*    markers={edit ? stationMarker : null}*/}
                                    {/*    getCoordinatesFromMap={getCoordinatesFromMap}*/}
                                    {/*    clickMarkerData={mapHasBeenClicked*/}
                                    {/*        ? {*/}
                                    {/*            lat: formValues.lat,*/}
                                    {/*            lng: formValues.lon,*/}
                                    {/*            color: '#E628B3'*/}
                                    {/*        }*/}
                                    {/*        : null*/}
                                    {/*    }*/}
                                    {/*    clickMarkerMap*/}
                                    {/*/>*/}
                                </div>
                                <div className="stationModalFormRow">
                                    <div className='userFormItem stationFormItem'>
                                        <label className='userFormLabel'>
                                            {t.gettext('Latitude')}
                                        </label>
                                        <input
                                            className='userFormInput'
                                            onChange={e => {
                                                const nextLat = e.target.value;
                                                setFormValues({...formValues, lat: nextLat});
                                            }}
                                            onBlur={e => {
                                                const nextLat = normalizeCoordinateValue(e.target.value);
                                                setFormValues({...formValues, lat: nextLat});
                                            }}
                                            value={formValues.lat}
                                            type='text'
                                            inputMode='decimal'
                                        />
                                    </div>
                                    <div className='userFormItem stationFormItem'>
                                        <label className='userFormLabel'>
                                            {t.gettext('Longitude')}
                                        </label>
                                        <input
                                            className='userFormInput'
                                            onChange={e => {
                                                const nextLon = e.target.value;
                                                setFormValues({...formValues, lon: nextLon});
                                            }}
                                            onBlur={e => {
                                                const nextLon = normalizeCoordinateValue(e.target.value);
                                                setFormValues({...formValues, lon: nextLon});
                                            }}
                                            type='text'
                                            inputMode='decimal'
                                            value={formValues.lon}
                                        />
                                    </div>
                                </div>
                            </Fragment>
                        )}


                        <div className='userFormItem'>
                            <label className='userFormLabel'>
                                {t.gettext('Name')}
                            </label>
                            <input
                                style={error && !formValues.name ? {'borderBottom':'1px solid #D91212'} : null}
                                className='userFormInput'
                                defaultValue={station ? station.name : ''}
                                onInput={e => {
                                    setFormValues({...formValues, name: e.target.value});
                                }}
                                type='text'
                            />
                        </div>
                        <div className='userFormItem'>
                            <label className='userFormLabel'>
                                {t.gettext('Address')}
                            </label>
                            <input
                                className='userFormInput'
                                defaultValue={station ? station.address : ''}
                                onInput={e => {
                                    setFormValues({...formValues, address: e.target.value});
                                }}
                                type='text'
                            />
                        </div>
                        <div className='userFormItem weatherStationVirtualToggle'>
                            <label className='weatherStationCheckboxLabel'>
                                <input
                                    type='checkbox'
                                    checked={Boolean(formValues.virtual)}
                                    onChange={e => {
                                        setFormValues({
                                            ...formValues,
                                            virtual: e.target.checked,
                                            gcStationId: e.target.checked ? formValues.gcStationId : '',
                                            stationType: e.target.checked ? formValues.stationType : '',
                                            stationIdentifier: e.target.checked ? formValues.stationIdentifier : ''
                                        });
                                    }}
                                />
                                <span>{t.gettext('Virtual station (for iMetos etc.)')}</span>
                            </label>
                        </div>
                        {Boolean(formValues.virtual) && (
                            <Fragment>
                                <div className='userFormItem'>
                                    <label className='userFormLabel'>
                                        {t.gettext('Station type')}
                                    </label>
                                    <select
                                        className='userFormInput weatherStationSelectInput'
                                        value={formValues.stationType}
                                        onChange={e => {
                                            const selectedStationType = e.target.value;
                                            setFormValues({
                                                ...formValues,
                                                stationType: selectedStationType,
                                                stationIdentifier: selectedStationType === 'EDWIN_WEATHER_STATION'
                                                    ? formValues.stationIdentifier
                                                    : '',
                                                gcStationId: selectedStationType === 'EDWIN_WEATHER_STATION'
                                                    ? ''
                                                    : formValues.gcStationId
                                            });
                                        }}
                                    >
                                        <option value=''>{t.gettext('Select station type')}</option>
                                        <option value='METOS_STATION'>METOS_STATION</option>
                                        <option value='EDWIN_WEATHER_STATION'>EDWIN_WEATHER_STATION</option>
                                    </select>
                                </div>
                                {formValues.stationType === 'EDWIN_WEATHER_STATION' && (
                                    <div className='userFormItem'>
                                        <label className='userFormLabel'>
                                            {t.gettext('Edwin Identifier')}
                                        </label>
                                        <input
                                            className='userFormInput'
                                            value={formValues.stationIdentifier}
                                            onInput={e => {
                                                setFormValues({...formValues, stationIdentifier: e.target.value});
                                            }}
                                            type='text'
                                        />
                                    </div>
                                )}
                                {formValues.stationType !== 'EDWIN_WEATHER_STATION' && (
                                    <div className='userFormItem'>
                                        <label className='userFormLabel'>
                                            {t.gettext('GreenCloud id')}
                                        </label>
                                        <input
                                            className='userFormInput'
                                            value={formValues.gcStationId}
                                            onInput={e => {
                                                setFormValues({...formValues, gcStationId: e.target.value});
                                            }}
                                            type='text'
                                        />
                                    </div>
                                )}
                            </Fragment>
                        )}
                        {edit && (
                            <div className='userFormItem'>
                                <label className='userFormLabel'>
                                    {t.gettext('Code')}
                                </label>
                                <input
                                    className='userFormInput'
                                    defaultValue={station ? station.code : ''}
                                    type='text'
                                    readOnly
                                />
                            </div>
                        )}
                        {details && (
                            <div className='userFormItem'>
                                <label className='userFormLabel'>
                                    {t.gettext('User Name')}
                                </label>
                                <input

                                    className='userFormInput'
                                    defaultValue={station ? station.userName : ''}
                                    disabled
                                    // onInput={e => {
                                    //     setFormValues({...formValues, name: e.target.value});
                                    // }}
                                    type='text'
                                />
                            </div>
                        )}
                        {/*{!details && (*/}
                        {/*    <div className='userFormItem'>*/}
                        {/*        <label className='userFormLabel'>*/}
                        {/*            {t.gettext('Field Id')}*/}
                        {/*        </label>*/}
                        {/*        <input*/}
                        {/*            className='userFormInput'*/}
                        {/*            defaultValue={station ? station.fieldId : ''}*/}
                        {/*            onInput={e => {*/}
                        {/*                setFormValues({...formValues, fieldId: e.target.value});*/}
                        {/*            }}*/}
                        {/*            type='text'*/}
                        {/*        />*/}
                        {/*    </div>*/}
                        {/*)}*/}
                        {!Boolean(formValues.virtual) && (
                            <Fragment>
                                <div className='userFormItem sensorPickerInput'>
                                    <label className='userFormLabel'>
                                        {t.gettext('Rain Sensor Id')}
                                    </label>
                                    <input
                                        readOnly
                                        className='userFormInput '
                                        onInput={e => {
                                            setFormValues({...formValues, rainSensorId: e.target.value});
                                        }}
                                        type='text'
                                        // defaultValue={station ? station.rainSensorId : formValues.rainSensorId}
                                        value={nameValues.rainSensorName}
                                    />
                                    <img className={'inputIcon icon--right'} src={searchIcon} alt='icon' onClick={() => toggleSensorsModal('rainSensorId', 'RAIN_COUNT_NO_TEMP', 'rainSensorName')} />
                                </div>
                                <div className='userFormItem sensorPickerInput'>
                                    <label className='userFormLabel'>
                                        {t.gettext('Wind Speed Sensor Id')}
                                    </label>
                                    <input
                                        readOnly
                                        className='userFormInput'
                                        onInput={e => {
                                            setFormValues({...formValues, windSpeedSensorId: e.target.value});
                                        }}
                                        type='text'
                                        // defaultValue={station ? station.windSpeedSensorName : formValues.windSpeedSensorId}
                                        value={nameValues.windSpeedSensorName}
                                    />
                                    <img className={'inputIcon icon--right'} src={searchIcon} alt='icon' onClick={() => toggleSensorsModal('windSpeedSensorId', 'WIND_SPEED_SENSOR', 'windSpeedSensorName')} />
                                </div>
                                <div className='userFormItem sensorPickerInput'>
                                    <label className='userFormLabel'>
                                        {t.gettext('Temperature/humidity Sensor Id')}
                                    </label>
                                    <input
                                        readOnly
                                        className='userFormInput'
                                        onInput={e => {
                                            setFormValues({...formValues, wetLeafSensorId: e.target.value});
                                        }}
                                        type='text'
                                        // defaultValue={station ? station.wetLeafSensorId : formValues.wetLeafSensorId}
                                        value={nameValues.wetLeafSensorName}
                                    />
                                    <img className={'inputIcon icon--right'} src={searchIcon} alt='icon' onClick={() => toggleSensorsModal('wetLeafSensorId', 'SHTTMP_SHTHUM_BLACK', 'wetLeafSensorName')} />
                                </div>
                                <div className='userFormItem sensorPickerInput'>
                                    <label className='userFormLabel'>
                                        {t.gettext('Dragino Wet Leaf Sensor Id')}
                                    </label>
                                    <input
                                        className='userFormInput'
                                        onInput={e => {
                                            setFormValues({...formValues, draginoWetLeafSensorId: e.target.value});
                                        }}
                                        readOnly
                                        type='text'
                                        // defaultValue={station && station.draginoWetLeafSensor ? station.draginoWetLeafSensor.name : formValues.draginoWetLeafSensorId}
                                        value={nameValues.draginoWetLeafSensorName}
                                    />
                                    <img className={'inputIcon icon--right'} src={searchIcon} alt='icon' onClick={()=> toggleSensorsModal('draginoWetLeafSensorId', 'WET_LEAF_DRAGINO_SENSOR', 'draginoWetLeafSensorName')} />
                                </div>
                                <div className='userFormItem sensorPickerInput'>
                                    <label className='userFormLabel'>
                                        {t.gettext('Soil Humidity Sensor Id')}
                                    </label>
                                    <input
                                        className='userFormInput'
                                        onInput={e => {
                                            setFormValues({...formValues, soilHumiditySensorId: e.target.value});
                                        }}
                                        readOnly
                                        type='text'
                                        // defaultValue={station ? station.soilHumiditySensorId : formValues.soilHumiditySensorId}
                                        value={nameValues.soilHumiditySensorName}
                                    />
                                    <img className={'inputIcon icon--right'} src={searchIcon} alt='icon' onClick={() => toggleSensorsModal('soilHumiditySensorId', 'SOIL_MOISTURE_SENSOR', 'soilHumiditySensorName' )} />
                                </div>
                            </Fragment>
                        )}
                        {!isCustomer() &&
                            <div className='userFormItem sensorPickerInput'>
                                <label className='userFormLabel'>
                                    {t.gettext('User')}
                                </label>
                                <input
                                    readOnly
                                    style={error && !formValues.userId ? {'borderBottom':'1px solid #D91212'} : null}
                                    className='userFormInput'
                                    onInput={e => {
                                        setFormValues({...formValues, userId: e.target.value});
                                    }}
                                    type='text'
                                    value={nameValues.userName}
                                    // defaultValue={station ? station.userId : formValues.userId}
                                    // value={formValues.userId}
                                />
                                <img className={'inputIcon icon--right'} src={searchIcon} alt='icon'
                                     onClick={() => toggleUsersModal()}/>
                            </div>
                        }
                        <div className='userButtonsHolder'>
                            {!edit &&
                            <button
                                className='userAddButton'
                                onClick={e => {
                                    e.preventDefault();
                                    handleAddStationClick();
                                }}
                                disabled={disableButtons}
                            >
                                {t.gettext('Add Station')}
                                {disableButtons && <ButtonSpinner black/>}
                            </button>
                            }

                            {edit &&

                            <>
                                <button
                                    className='userAddButton weatherStationUsersAccessButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        setStationUsersAccessModal(true);
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Add users')}
                                </button>
                                <button
                                    className='userAddButton userDeleteButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleDeleteStationClick();
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Delete Station')}
                                </button>
                                <button
                                    className='userAddButton userEditButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleAddStationClick();
                                        // handleEditUserClick();
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Save')}
                                    {disableButtons && <ButtonSpinner black/>}
                                </button>
                            </>

                            }
                        </div>
                            {deleteConfirmation &&
                            <div className='userDeleteConfirmation' style={{justifyContent: 'center'}}>
                                {station.name + ' ' + t.gettext('will be deleted')}
                                <button
                                    className='confirmationButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        confirmDeleteWeatherStation(station.id);
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('OK')}
                                </button>
                                <button
                                    className='confirmationButton confirmationButton--cancel'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleDeleteStationClick();
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Cancel')}
                                </button>
                            </div>
                        }
                        {/*<div className='userButtonsHolder'>*/}
                        {/*    {edit &&*/}
                        {/*    <button*/}
                        {/*        className='userAddButton userEditButton'*/}
                        {/*        onClick={e => {*/}
                        {/*            e.preventDefault();*/}
                        {/*            // handleClearDeviceIdsClick();*/}
                        {/*        }}*/}
                        {/*        disabled={disableButtons}*/}
                        {/*    >*/}
                        {/*        {t.gettext('Clear device Ids')}*/}
                        {/*        {disableButtons && <ButtonSpinner black/>}*/}
                        {/*    </button>*/}
                        {/*    }*/}
                        {/*    {edit &&*/}
                        {/*    <button*/}
                        {/*        className='userAddButton userEditButton'*/}
                        {/*        onClick={e => {*/}
                        {/*            e.preventDefault();*/}
                        {/*            // handleResetPasswordClick();*/}
                        {/*        }}*/}
                        {/*        disabled={disableButtons}*/}
                        {/*    >*/}
                        {/*        {t.gettext('Reset password')}*/}
                        {/*        {disableButtons && <ButtonSpinner black/>}*/}
                        {/*    </button>*/}
                        {/*    }*/}
                        {/*</div>*/}
                        {sensorsModal.isOpen &&
                            <ExternalModal
                                closeMethod={() => toggleSensorsModal(sensorsModal.type)}
                                title={'Sensors'}
                            >
                                <Sensor
                                    sensorPicker
                                    sensorPickerEnum={sensorsModal.enumType}
                                    selectSensorPicker={selectSensorId}
                                    sensorPickerType={sensorsModal.type}
                                    sensorPickerName={sensorsModal.name}
                                    toggleSensorPicker={toggleSensorsModal}
                                    userId={formValues.userId}
                                />
                            </ExternalModal>
                        }
                        {usersModal.isOpen &&
                            <ExternalModal
                                closeMethod={() => toggleUsersModal()}
                                title={'Users'}
                                >
                            <ManageUsers
                                superAdmin={isSuperAdmin()}
                                userPicker
                                selectUserPicker={selectUserId}
                                toggleUserPicker={toggleUsersModal}
                            />
                            </ExternalModal>
                        }
                        {stationUsersAccessModal && station && station.id &&
                            <UserAccessModal
                                t={t}
                                itemId={station.id}
                                idKey='stationId'
                                getEndpoint='weather_station_users/getUsersForStation'
                                setEndpoint='weather_station_users/setUsersForStation'
                                closeMethod={() => setStationUsersAccessModal(false)}
                            />
                        }
                    </form>
                </div>
            </div>
        </div>
    );
}

export default WeatherStationModal
